import type { RepoRagEmbeddingModel } from "./configData";

export interface SkillMeshEmbeddingConfig {
  dimensions: number;
  model: RepoRagEmbeddingModel;
  semanticBand: number;
  semanticFloor: number;
}

export const skillMeshEmbeddingConfig: SkillMeshEmbeddingConfig = {
  dimensions: 1536,
  model: "text-embedding-3-small",
  semanticBand: 0.08,
  semanticFloor: 0.25,
};
